import angular from 'angular'
import outputInvoicePool from './outputInvoicePool'

export default angular.module('outputManage.invoicePool', [outputInvoicePool]).config([
    '$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('outputManage.invoicePool', {
            url: '/ovat',
            template: '<div ui-view></div>',
            abstract: true,
            title: '发票池',
        })
    },
]).name



// WEBPACK FOOTER //
// ./src/app/outputManage/invoicePool/index.js